import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/variables.css";
import App from "./App";
import AppSA from "./App.standalone";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router";

const root = ReactDOM.createRoot(document.getElementById("root"));
console.log(process.env.REACT_APP_VARIANT)
root.render(
  <React.StrictMode>
    <BrowserRouter>
      {process.env.REACT_APP_VARIANT === "standalone" ? <AppSA /> : <App />}
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
